import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["element", "button", "divToAlign", "accordion"];

  connect() {}

  toggle(event) {
    event.preventDefault();
    if (this.elementTarget.classList.contains("active")) {      
      this.elementTarget.classList.remove("active");
      this.buttonTarget.classList.remove('btn-secondary', 'opacity-30-percent');
      this.buttonTarget.innerHTML = 'Continue';
      this.divToAlignTarget.classList.remove('align-to-right');
      this.accordionTarget.classList.add('d-none');
    } else {
      this.elementTarget.classList.add("active");
      this.accordionTarget.classList.remove('d-none');
      this.buttonTarget.classList.add('btn-secondary', 'opacity-30-percent');
      this.buttonTarget.innerHTML = '<i style="font-size:20px" class="fa">&#xf00d;</i>';
      this.divToAlignTarget.classList.add('align-to-right');
      const reservationFormID = this.buttonTarget.dataset['target'].split('-', 2)[1];
      const divElement = document.getElementById("li-"+reservationFormID);
      divElement.scrollIntoView({behavior: "smooth", block: "start", inline: "end"});
    }
  }
}